export default "__VITE_ASSET__Dk1cUwJ2__"